export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2023.c776759e.pdf";